<div class="card text-center position-absolute top-0 start-50 translate-middle w-75">
    <div class="card-header h3" style="color: #ea4f00; font-weight: bold;">
      Important Info
    </div>
    <div class="card-body">
      <h5 class="card-title" style="font-weight: bold;">Redirect to login beofre creating a listing</h5>
      <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste, similique consequatur delectus vero, amet nihil molestiae dolore aperiam possimus ex temporibus id laudantium! Ab minus culpa soluta quis, nihil at?</p>
        <button
            class="btn btn-primary btn-round hvr-push mt-5 mb-5"
            (click)="onCreateListingClick()"
            routerLink="create-listing-proxy"
            >
            Create a Listing
        </button>
    </div>
    <div class="card-footer text-body-secondary">
      Thank You For Your Interest In OutdoorAccess
    </div>
  </div>